import Aegis from 'aegis-web-sdk';

export default function aegisInitializer() {
 let NODE_ENV = process.env.NODE_ENV
     if (typeof Aegis === 'function') {
        var aegis = new Aegis({
          id: '8ljeOIoz6azmzOa9EV', // 上报 id
          uin: 'xxx', // 用户唯一 ID（可选）
          reportApiSpeed: true, // 接口测速
          reportAssetSpeed: true, // 静态资源测速
          onError: true, // 静态资源测速
          spa: true, // spa 应用页面跳转的时候开启 pv 计算
          hostUrl: 'https://rumt-zh.com',
          env:NODE_ENV
        });
   }
}